@if(descriptionHtml){
  <div [innerHTML]="descriptionHtml"></div>
}@else{
  <header class="header max-width" [ngStyle]="{'background-color':commentcardStyles?.HeaderBackground}">
    <div class="header__property-detail u-margin-bottom-small">
      <div class="header__logo-box">
        <img [src]="'data:image/png;base64,'+ image" alt="" class="header__logo">
      </div>
      @if (getsurveyelement && getsurveyelement.Payload) {
        <h1 class="header__text-box" [ngStyle]="{'color':commentcardStyles?.HeaderTextColor, 'font-family':commentcardStyles?.HeaderFont}">{{getsurveyelement?.Payload?.Contact?.VisitStats[0].RestaurantName}}</h1>
      }
    </div>
    <div class="header__property-address u-margin-bottom-small max-width">
      <p class="header__address-text" [ngStyle]="{'color':commentcardStyles?.HeaderTextColor, 'font-family':commentcardStyles?.HeaderFont}">
        <mat-icon class="location_on" aria-hidden="false" aria-label="location" >location_on</mat-icon>
        <span> {{getrestaurantaddress?.City}}, {{getrestaurantaddress?.Country }}, {{getrestaurantaddress?.PhoneNumber}}</span>
      </p>
    </div>
  </header>
}
